<hero-header [accountMenuItems]="accountMenuItems"></hero-header>

<div class="container">
  <router-outlet></router-outlet>
</div>
